import { useEffect } from 'react';
import { withRouter } from 'react-router';

import withAuthentication from '../helpers/withAuthentication';

const Home = ({ user, history }) => {
  useEffect(() => {
    if (user && user.is_vendor) {
      const vendor = user.vendors[0];
      history.push(`/vendor/${vendor.id}/admin/markets`);
    } else {
      history.push('/customer-home');
    }
  }, [user, history]);
  return <></>;
};

export default withAuthentication(withRouter(Home));
